import { render, staticRenderFns } from "./OxVicon.vue?vue&type=template&id=12c7882a"
import script from "./OxVicon.ts?vue&type=script&lang=ts&external"
export * from "./OxVicon.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports